import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Page = styled.div`
  max-width: 800px;
  margin: 40px auto;
  padding: 0 20px;
  color: #fff;
`;

const OrderCancel = () => {
  return (
    <Page>
      <h2 style={{ color: '#e1d6c0' }}>Payment Canceled</h2>
      <p>Your payment was canceled or failed. You can try again.</p>
      <p>
        Return to your <Link to="/order">Order</Link> or browse the <Link to="/menu">Menu</Link>.
      </p>
    </Page>
  );
};

export default OrderCancel;

